import { Link, useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "@/Redux/authSlice";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { User, Home, LogOut, Settings, List, Heart, Building, MessageCircle, MessageSquare, HomeIcon, Users, DollarSign, NotepadText } from "lucide-react";
import axiosInstance from "@/lib/axiosInstance";
import { Chip } from "@mui/material";
import CustomBreadcrumbs from "./BreadCrumbs";
import { useState } from "react";

export default function Header() {
  const [location, navigate] = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state: any) => state.auth);

  // const { data: favorites = [] } = useQuery<any[]>({
  //   queryKey: ["/api/favorites"],
  //   queryFn: async () => {
  //     if (!user) return { isFavorite: false };
  //     if (user.userType == "seller") return { isFavorite: false };
  //     const res = await axiosInstance.get("/api/favorites");
  //     return res.data;
  //   },
  //   enabled: isAuthenticated,
  // });

  const navigationItems :any = [
    // { href: "/", label: "Buy", active: location === "/" },
    // { href: "/rent", label: "Rent", active: location === "/rent" },
    // { href: "/share", label: "Share", active: location === "/share" },
    // { href: "/sold", label: "Sold", active: location === "/sold" },
    // { href: "/new-homes", label: "New Homes", active: location === "/new-homes" },
    // { href: "/commercial", label: "Commercial", active: location === "/commercial" },
  ];

  const logoutUser = () => {
    dispatch(logout());
    sessionStorage.clear();
    navigate("/");
  };

  return (
    <>
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div>
              <CustomBreadcrumbs user={user} />
            </div>

            {/* Navigation Menu */}
            {/* <nav className="hidden md:flex space-x-8 mt-2">
              {navigationItems.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  className={`font-medium pb-1 transition-colors ${item.active
                    ? "text-gray-900 border-b-2 border-primary"
                    : "text-gray-700 hover:text-primary"
                    }`}
                  data-testid={`link-nav-${item.label.toLowerCase().replace(' ', '-')}`}
                >
                  {item.label}
                </Link>
              ))}
            </nav> */}

            {/* User Actions */}
            <div className="flex items-center space-x-4">
              {isAuthenticated ? (
                <>
                  {user?.userType == "buyer" && <Link href="/favorites" className="hidden md:flex items-center text-gray-700 hover:text-primary" data-testid="link-favorites">
                    <i className="fas fa-heart mr-1"></i>
                    {/* Favourites
                    {favorites.length > 0 && (
                      <span className="ml-1 bg-primary text-white text-xs rounded-full px-2 py-1" data-testid="text-favorites-count">
                        {favorites.length}
                      </span>
                    )} */}
                  </Link>}

                  <UserDropdown user={user} logoutUser={logoutUser} />
                </>
              ) : (
                <>
                  <Button className="hidden md:flex bg-secondary text-white hover:bg-green-700" data-testid="button-place-ad">
                    Place Ad
                  </Button>
                  <Link href="/login" data-testid="link-login">
                    <button
                      className="flex items-center gap-2 px-4 py-2 rounded-lg border border-gray-300 text-gray-700 
                hover:bg-primary hover:text-white transition-colors duration-200 shadow-sm"
                      data-testid="button-login"
                    >
                      <i className="fas fa-user-circle text-lg"></i>
                      <span className="font-medium">Login</span>
                    </button>
                  </Link>

                </>
              )}

              {/* Mobile Menu Button */}
              <button
                className="md:hidden text-gray-700"
                data-testid="button-mobile-menu"
                onClick={() => setMobileMenuOpen((prev) => !prev)}
              >
                <i className="fas fa-bars text-xl"></i>
              </button>
            </div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t shadow-sm px-4 py-3 space-y-2">
            {navigationItems.map((item :any) => (
              <Link
                key={item.href}
                href={item.href}
                className={`block font-medium py-2 ${item.active ? "text-primary" : "text-gray-700 hover:text-primary"
                  }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}

            {!isAuthenticated ? (
              <>
                <Button className="w-full bg-secondary text-white hover:bg-green-700 mt-2" data-testid="button-place-ad">
                  Place Ad
                </Button>
                <Link href="/login" data-testid="link-login">
                  <button
                    className="w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg border border-gray-300 text-gray-700 
                    hover:bg-primary hover:text-white transition-colors duration-200 shadow-sm mt-2"
                    data-testid="button-login"
                  >
                    <i className="fas fa-user-circle text-lg"></i>
                    <span className="font-medium">Login</span>
                  </button>
                </Link>
              </>
            ) : (
              user?.userType == "buyer" && <Link href="/favorites" className="hidden md:flex items-center text-gray-700 hover:text-primary" data-testid="link-favorites">
                <i className="fas fa-heart mr-1"></i>
                {/* Favourites
                {favorites.length > 0 && (
                  <span className="ml-1 bg-primary text-white text-xs rounded-full px-2 py-1" data-testid="text-favorites-count">
                    {favorites.length}
                  </span>
                )} */}
              </Link>
            )}
          </div>
        )}
      </header>
    </>
  );
}


export function UserDropdown({ user, logoutUser }: { user: any; logoutUser: () => void }) {
  const [location] = useLocation();

  let menuItems : any[] = [
      // { href: "/admin/dashboard", label: "Dashboard", icons: <HomeIcon className="w-6 h-6 text-gray-700" /> },
      // { href: "/admin/users", label: "Users", icons: <Users className="w-6 h-6 text-gray-700" /> },
      // { href: "/admin/property", label: "Property", icons: <Building className="w-6 h-6 text-gray-700" /> },
      // { href: "/admin/subscriptions", label: "Subscriptions", icons: <DollarSign className="w-6 h-6 text-gray-700" /> },
      // { href: "/admin/account", label: "Account", icons: <User className="w-6 h-6 text-gray-700" /> },

  ]

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className="p-1 rounded-full hover:shadow-md transition">
          <div className="flex items-center space-x-2">
            {user?.avatar ? (
              <>

                <img
                  src={user?.avatar}
                  alt="Profile"
                  className="w-8 h-8 rounded-full object-cover"
                />
                &nbsp; {user?.firstName}
              </>
            ) : (
              <>
                <User className="w-6 h-6 text-gray-700" /> &nbsp; {user?.firstName}
              </>
            )}
            {["agent", "seller"].includes(user.userType) && <Chip
              label={user?.userType}
              sx={{ backgroundColor: user?.userType === "seller" ? "green" : "orange", textTransform: "capitalize", color: "white" }}
            />}
          </div>
        </Button>
      </PopoverTrigger>

      <PopoverContent className="w-56 p-2 shadow-lg rounded-xl border bg-white">
        <ul className="space-y-1">
          {menuItems.map((item) => {
            const isActive = location === item.href;
            return (
              <li key={item.href}>
                <Link
                  href={item.href}
                  className={`flex items-center space-x-2 p-2 rounded-lg transition ${isActive
                    ? "bg-primary text-white shadow-md"
                    : "hover:bg-gray-100 hover:text-blue-600"
                    }`}
                >
                  {item.icons}
                  <span>{item.label}</span>
                </Link>
              </li>
            );
          })}

          <li className="border-t pt-2 mt-2">
            <button
              onClick={logoutUser}
              className="w-full text-left flex items-center space-x-2 p-2 rounded-lg hover:bg-red-100 hover:text-red-600 transition"
            >
              <LogOut className="w-4 h-4" />
              <span>Logout</span>
            </button>
          </li>
        </ul>
      </PopoverContent>
    </Popover>
  );
}
